<div class="user-settings-container">
  <h1>{{ dataService.getTexts().UserSettingsTitle }}</h1>
  <div class="settings-content">
    <section class="settings-section" aria-labelledby="profile-heading">
      <h2 id="profile-heading">{{ dataService.getTexts().Profile }}</h2>
      @if (profileLoading) {
        <p class="profile-state" role="status">{{ dataService.getTexts().UserSettingsProfileLoading }}</p>
      } @else if (profileError) {
        <div class="profile-state" role="alert">
          <p>{{ dataService.getTexts().UserSettingsProfileError }}</p>
          <button type="button" class="action-button" (click)="loadUserData()">
            {{ dataService.getTexts().CostsDashboardRetryButton }}
          </button>
        </div>
      } @else {
        <div class="profile-card">
          <div class="profile-avatar" aria-hidden="true">
            @if (avatar) {
              <img [src]="pic" alt="" class="avatar-image" (error)="clearProfilePicture()" />
            } @else {
              <i class="pi pi-user"></i>
            }
          </div>
          <div class="profile-info">
            <h3 class="profile-name">{{ username }}</h3>
            <p class="profile-email">{{ email }}</p>
            <div class="profile-role">
              @if (isAdmin) {
                <span>{{ dataService.getTexts().UserSettingsRoleAdmin }}</span>
              }
              @if (isInstanceAdmin) {
                <span>{{ dataService.getTexts().UserSettingsRoleInstanceAdmin }}</span>
              }
              @if (!isAdmin && !isInstanceAdmin) {
                <span>{{ dataService.getTexts().UserSettingsRoleUser }}</span>
              }
            </div>
          </div>
        </div>
      }
    </section>

    <section class="settings-section">
      <fieldset class="language-settings" aria-describedby="language-hint">
        <legend>{{ dataService.getTexts().UserMenuLanguage }}</legend>
        <p id="language-hint" class="settings-hint">{{ dataService.getTexts().UserSettingsLanguageHint }}</p>
        <div class="language-options">
          <label class="language-option" [class.active]="dataService.getLanguage() === 'de'">
            <input type="radio" name="portal-language" value="de" [formControl]="languageControl" />
            <span lang="de">{{ dataService.getTexts().UserSettingsLanguageGerman }}</span>
          </label>
          <label class="language-option" [class.active]="dataService.getLanguage() === 'en'">
            <input type="radio" name="portal-language" value="en" [formControl]="languageControl" />
            <span lang="en">{{ dataService.getTexts().UserSettingsLanguageEnglish }}</span>
          </label>
        </div>
        @if (languageError) {
          <p class="settings-error" role="alert">{{ dataService.getTexts().UserSettingsLanguageError }}</p>
        }
      </fieldset>
    </section>

    <section class="settings-section" aria-labelledby="account-heading">
      <h2 id="account-heading">{{ dataService.getTexts().Account }}</h2>
      <button type="button" class="action-button" (click)="signOut()">
        <i class="pi pi-sign-out" aria-hidden="true"></i>
        <span>{{ dataService.getTexts().UserMenuLogoutButtonText }}</span>
      </button>
    </section>
  </div>
</div>
